import { InjectedTranslateProps, translate } from 'react-i18next';
import { Box, Text, TextButton } from 'wix-style-react';
import { KBLinks } from '@src/constants';
import * as React from 'react';

export interface Props extends InjectedTranslateProps {
  kbLinks: KBLinks;
}

export const ReviewCookieCollapsedContent = translate()(({ t, kbLinks }: Props) => {
  const renderBullet = (title: string, subtitle: string, learnMoreUrl: string) => (
    <li>
      <Box direction={'vertical'} marginBottom={'24px'}>
        <Text weight={'bold'}>
          {t(title)} <TextButton onClick={() => window.open(learnMoreUrl, '_blank')}>{t('learn.more')}</TextButton>
        </Text>
        <Text>{t(subtitle)}</Text>
      </Box>
    </li>
  );

  return (
    <Box direction={'vertical'} marginTop={'12px'}>
      <Box>
        <Text>{t('review.cookie.policy.details')}</Text>
      </Box>
      <Box direction={'vertical'}>
        <ul>
          {renderBullet(
            'review.cookie.policy.item1.title',
            'review.cookie.policy.item1.subtitle',
            kbLinks.ReviewCookieSocialFeatures,
          )}
          {renderBullet(
            'review.cookie.policy.item2.title',
            'review.cookie.policy.item2.subtitle',
            kbLinks.ReviewCookieThirdParty,
          )}
          {renderBullet(
            'review.cookie.policy.item3.title',
            'review.cookie.policy.item3.subtitle',
            kbLinks.ReviewCookieCustomCode,
          )}
        </ul>
      </Box>
    </Box>
  );
});
